module.exports = __webpack_public_path__ + "static/ocean-2-1808925d6ad23cf93ce99f1732476c0b.mp4";